import { HELP_CENTER_ROLE_LABEL } from '@/lib/article-author';
import type { SiteStaffRole } from '@/lib/cms-types';
import type { PainelMockUser } from '@/lib/painel-rbac';

export const HELP_CENTER_STAFF_ROLE_ORDER: SiteStaffRole[] = [
  'mainOwner',
  'owners',
  'moderadores',
  'membros',
];

export function resolvePainelUserHelpCenterRoleOption(
  user: Pick<PainelMockUser, 'helpCenterRole'>
): SiteStaffRole | 'none' {
  if (user.helpCenterRole === null || user.helpCenterRole === undefined) return 'none';
  return user.helpCenterRole;
}

export function helpCenterRoleOptionToValue(id: SiteStaffRole | 'none'): SiteStaffRole | null {
  return id === 'none' ? null : id;
}

export function helpCenterRoleLabel(role: SiteStaffRole | null | undefined): string | undefined {
  if (!role) return undefined;
  return HELP_CENTER_ROLE_LABEL[role];
}
